import { useTranslate, useNavigation } from '@pankod/refine-core'

import { Row, Col, AntdLayout, Card, Typography, Form, Input, Button, message } from '@pankod/refine-antd'
import { changePassword, resetPassword } from 'users'
import { useState } from 'react'
import useVerifyUserLogged from 'CustomHook/useVerifyUserLogedIn'
import './style.less'
const { Text, Title } = Typography
export interface IResetPassword {
  password: string
}

export const ChangePasswordPage: React.FC = () => {
  const [form] = Form.useForm<IResetPassword>()
  const t = useTranslate()
  const { push } = useNavigation()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  useVerifyUserLogged()

  const CardTitle = (
    <div style={{ textAlign: 'center' }}>
      <img style={{ width: '150px' }} src="/images/logo.jpg" width="100%" />
    </div>
  )

  const success = (msg: string, type: string) => {
    form.resetFields()
    if (type === 'success') {
      message.success(msg)
    } else message.error(msg)
  }
  return (
    <AntdLayout>
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <div style={{ maxWidth: '408px', margin: 'auto' }}>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }} style={{ border: 'none', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
              <Form<IResetPassword>
                layout="vertical"
                form={form}
                onFinish={values => {
                  if (password !== '' && confirmPassword !== '' && password === confirmPassword)
                    changePassword(values?.password).then(response => {
                      form.resetFields()
                      if (response === 'OK') {
                        success('Password Changed', 'success')
                        push('/login')
                      } else {
                        success(response, 'danger')
                      }
                    })
                }}
                requiredMark={false}
              >
                <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Enter your password' }]}>
                  <Input.Password onChange={e => setPassword(e.target?.value)} />
                </Form.Item>
                <Form.Item
                  name="confirm_password"
                  label="Confirm Password"
                  rules={[
                    {
                      validator: async (_, confirm_password) => {
                        if (confirm_password !== password) {
                          return Promise.reject(new Error('Password Mismatch'))
                        }
                      },
                    },
                    { required: true, message: 'Enter confirm password' },
                  ]}
                >
                  <Input.Password onChange={e => setConfirmPassword(e.target?.value)} />
                </Form.Item>

                <div style={{ float: 'right', marginTop: '10px',width:'100%' }}>
                  <Button type="primary" htmlType="submit" className='gradient-button' style={{width:'100%'}}>
                    Reset Password
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  )
}
